// Хронологията: секционен надпис и списък от редове, разделени с тънка черта.
// Скролът е тук, а не на целия прозорец — хедърът, кутийките и лентата с
// действия остават на място.

import { Spin } from "antd";
import { useTranslation } from "react-i18next";

import type { OpEvent } from "../../../../api/billOperations";
import { BillOperationEventRow } from "./BillOperationEventRow";

type Props = {
  events: OpEvent[] | undefined;
  isLoading: boolean;
  billName: string;
  billWaiterId: number | null;
  language: string;
  isNarrow: boolean;
};

export const BillOperationsTimeline = ({
  events,
  isLoading,
  billName,
  billWaiterId,
  language,
  isNarrow,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-0 flex-1 overflow-y-auto">
      <p
        className={`font-pos-mono text-[10.5px] font-bold uppercase leading-none tracking-[0.14em] text-muted ${
          isNarrow ? "px-4 pb-2 pt-4" : "px-6 pb-2.5 pt-5"
        }`}
      >
        {t("reportsPage.billOpsSectionOperations")}
      </p>

      {isLoading ? (
        <div className="flex justify-center py-12">
          <Spin />
        </div>
      ) : null}

      {!isLoading && (events?.length ?? 0) === 0 ? (
        <p className="py-10 text-center text-[13px] font-medium text-muted">
          {t("reportsPage.billOpsEmpty")}
        </p>
      ) : null}

      {!isLoading && events && events.length > 0 ? (
        <ul className="m-0 list-none p-0">
          {events.map((event, index) => (
            <BillOperationEventRow
              // Едно събитие няма собствен id — BE-то ги сглобява от няколко
              // таблици; ключът е позицията в подредената хронология.
              key={`${event.type}-${event.at}-${index}`}
              event={event}
              billName={billName}
              billWaiterId={billWaiterId}
              language={language}
              isNarrow={isNarrow}
            />
          ))}
        </ul>
      ) : null}
    </div>
  );
};
